export const Categories = [
  {
    id: 'case_introduction',
    parentLabel: 'Strategic Context & Scoping',
    label: 'Strategic Context & Scoping',
    imgSrc: 'https://assets.languify.in/images/caseIntro.png',
    score: 50,
    description: 'Evaluates your ability to understand the case context, identify key issues, and articulate relevant questions',
    subCategories: [
      {
        id: 'RELEVANCE',
        label: 'Relevance',
        weightage: 33.33,
        description: 'The ability to logically deconstruct the problem and devise a step-by-step, efficient solution while considering all given constraints.'
      },
      {
        id: 'DEPTH',
        label: 'Depth',
        weightage: 33.33,
        description: 'The depth of understanding and analysis demonstrated in the case introduction.'
      },
      {
        id: 'CLARITY',
        label: 'Clarity',
        weightage: 33.34,
        description: 'The clarity and coherence in explaining thought processes and logic.'
      }
    ]
  },
  {
    id: 'hypothesis_framework',
    label: 'Logic Tree & MECE Structure',
    imgSrc: 'https://assets.languify.in/images/coreConcepts.png',
    description: 'Assesses your ability to develop structured hypotheses and create logical frameworks for problem-solving',
    subCategories: [
      {
        id: 'LOGIC',
        label: 'Logic',
        weightage: 50,
        description: 'The logical structure and reasoning behind the framework approach'
      },
      {
        id: 'FEASIBILITY',
        label: 'Feasibility',
        weightage: 50,
        description: 'The practicality and implementability of the proposed framework'
      }
    ]
  },
  {
    id: 'data_analysis',
    label: 'Quantitative Synthesis',
    imgSrc: 'https://assets.languify.in/images/dataAnalysis.png',
    description: 'Measures your capability to interpret data, perform calculations, and derive meaningful insights',
    subCategories: [
      {
        id: 'PRECISION',
        label: 'Precision',
        weightage: 33.33,
        description: 'Accuracy and correctness in data analysis and calculations'
      },
      {
        id: 'INSIGHTFULNESS',
        label: 'Insightfulness',
        weightage: 33.33,
        description: 'Depth and quality of insights derived from data analysis'
      },
      {
        id: 'THOROUGHNESS',
        label: 'Thoroughness',
        weightage: 33.34,
        description: 'Completeness and comprehensiveness of the data analysis'
      }
    ]
  },
  {
    id: 'hypothesis_testing',
    label: 'Root Cause Validation',
    imgSrc: 'https://assets.languify.in/images/hypothesisTesting.png',
    description: 'Evaluates your approach to validating hypotheses, identifying risks, and ensuring practical applicability',
    subCategories: [
      {
        id: 'VALIDATION',
        label: 'Validation',
        weightage: 33.33,
        description: 'Rigor and thoroughness in testing and validating hypotheses'
      },
      {
        id: 'MITIGATION',
        label: 'Mitigation',
        weightage: 33.33,
        description: 'Ability to address potential issues and risks in hypothesis testing'
      },
      {
        id: 'PRACTICALITY',
        label: 'Practicality',
        weightage: 33.34,
        description: 'Practical feasibility and real-world applicability of the testing approach'
      }
    ]
  },
  {
    id: 'conclusion',
    label: 'Conclusion',
    imgSrc: 'https://assets.languify.in/images/conclusion.png',
    description: 'Assesses your ability to synthesize findings into actionable recommendations aligned with strategic goals',
    subCategories: [
      {
        id: 'ACTIONABILITY',
        label: 'Actionability',
        weightage: 50,
        description: 'The extent to which recommendations are specific, implementable, and actionable'
      },
      {
        id: 'STRATEGIC_ALIGNMENT',
        label: 'Strategic Alignment',
        weightage: 50,
        description: 'How well the conclusions align with strategic business objectives and priorities'
      }
    ]
  },
  {
    id: 'speech',
    label: 'Speech',
    imgSrc: 'https://assets.languify.in/images/speech4c.png',
    description: 'Ability to articulate thoughts clearly and effectively',
    subCategories: [
      {
        id: 'FLUENCY',
        label: 'Fluency',
        weightage: 50,
        description: 'Ability to speak smoothly, with clear, continuous flow, and minimal pauses or disruptions'
      },
      {
        id: 'DELIVERY',
        label: 'Delivery',
        weightage: 50,
        description: 'How someone talks, focusing on how fast they speak & their energy level'
      }
    ]
  }
];

export const SubCategoryWeightages = [
  { subCategory: 'RELEVANCE', weightage: 6.67 },
  { subCategory: 'DEPTH', weightage: 6.67 },
  { subCategory: 'CLARITY', weightage: 6.66 },
  { subCategory: 'LOGIC', weightage: 12.5 },
  { subCategory: 'FEASIBILITY', weightage: 12.5 },
  { subCategory: 'PRECISION', weightage: 8.33 },
  { subCategory: 'INSIGHTFULNESS', weightage: 8.33 },
  { subCategory: 'THOROUGHNESS', weightage: 8.34 },
  { subCategory: 'VALIDATION', weightage: 5 },
  { subCategory: 'MITIGATION', weightage: 5 },
  { subCategory: 'PRACTICALITY', weightage: 5 },
  { subCategory: 'ACTIONABILITY', weightage: 7.5 },
  { subCategory: 'STRATEGIC_ALIGNMENT', weightage: 7.5 },
  { subCategory: 'FLUENCY', weightage: 2.5 },
  { subCategory: 'DELIVERY', weightage: 2.5 }
];

// Axes of the performance radar, clockwise from the top vertex. V1.1 puts one
// evaluation parameter on each axis rather than a category average, so every
// axis names the category it sits in and the parameter it reads.
export const RadarAxes = [
  { id: 'logic', label: 'Logic', categoryId: 'hypothesis_framework', parameterId: 'LOGIC' },
  { id: 'communication', label: 'Communication', categoryId: 'speech', parameterId: 'FLUENCY' },
  { id: 'delivery', label: 'Delivery', categoryId: 'speech', parameterId: 'DELIVERY' },
  { id: 'structuring', label: 'Structuring', categoryId: 'case_introduction', parameterId: 'RELEVANCE' },
  { id: 'insight', label: 'Insight', categoryId: 'data_analysis', parameterId: 'INSIGHTFULNESS' },
  { id: 'quantitative', label: 'Quantitative', categoryId: 'data_analysis', parameterId: 'THOROUGHNESS' }
];

export const RadarTitle = 'Performance Radar: You vs. Ideal Candidate';

// The benchmark is a constant - no attempt carries one. 90 matches the "90+
// mark" in the chart title and the 9+ ideal candidate threshold on the score
// scale.
export const IdealCandidateScore = 90;

// Rings drawn behind the two series, as the 0-100 scale markers.
export const RadarScaleMarkers = [25, 50, 75, 100];

// Score scale benchmarks: a fixed 9+ ideal candidate threshold, and a next
// achievable score one 20% improvement away, rounded up to the nearest half
// point and capped at the threshold.
export const IdealCandidateThreshold = 9;
export const ImprovementFactor = 1.2;
export const NextScoreStep = 0.5;

// Reaction tags the evaluation can attach to a candidate answer, in the order
// the filter row lists them. `tone` picks the chip palette.
export const TranscriptReactions = [
  { id: 'EXCELLENT', label: 'Excellent', emoji: '⭐', tone: 'positive' },
  { id: 'GOOD', label: 'Good', emoji: '👍', tone: 'positive' },
  { id: 'SHARPER', label: 'Sharper', emoji: '🤔', tone: 'improve' },
  { id: 'CONCERN', label: 'Concern', emoji: '⚠️', tone: 'improve' },
  { id: 'MISSED', label: 'Missed', emoji: '❌', tone: 'negative' },
  { id: 'DELIVERY', label: 'Delivery', emoji: '💬', tone: 'neutral' }
];
